import { render, staticRenderFns } from "./cell-image.vue?vue&type=template&id=0ef52178&scoped=true"
import script from "./cell-image.ts?vue&type=script&lang=ts&external"
export * from "./cell-image.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef52178",
  null
  
)

export default component.exports